import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _noop from 'lodash/noop';

// Constants
import { EMPTY_OBJECT, EMPTY_ARRAY, EMPTY_STRING } from '@tekion/tekion-base/app.constants';

// Components
import FormBuilder from '../../../../FormBuilder';

// Styles
import s from './filterList.module.scss';
var FilterList = function FilterList(props) {
  var fields = props.fields,
    values = props.values,
    onAction = props.onAction,
    sections = props.sections,
    className = props.className;
  return /*#__PURE__*/React.createElement(FormBuilder, {
    className: cx(s.container, className, 'overflow-y-auto'),
    fields: fields,
    values: values,
    onAction: onAction,
    sections: sections
  });
};
FilterList.propTypes = {
  fields: PropTypes.object,
  values: PropTypes.object,
  onAction: PropTypes.func,
  sections: PropTypes.array,
  className: PropTypes.string
};
FilterList.defaultProps = {
  className: EMPTY_STRING,
  fields: EMPTY_OBJECT,
  values: EMPTY_OBJECT,
  onAction: _noop,
  sections: EMPTY_ARRAY
};
export default FilterList;